import { ActionIcons } from '@vt/vt-ui';
import React, { memo } from 'react';
import { z } from 'zod';
import { SymbolInfoSchema } from '../../../types/symbol';

// const SymbolItemPropsSchema = z.object({
//   maxW: z.boolean().optional(),
//   active: z.boolean(),
//   keyIndex: z.number(),
//   symbolInfo: SymbolInfoSchema,
//   handleClick: z.function(),
//   lastIndex: z.boolean()
// });

// export { SymbolItemPropsSchema };

const SymbolItem = memo(function SymbolItem(props) {
  return (
    <div
      style={{
        transition: 'all 0.3s ease-in',
        filter: props?.maxW ? (props?.active ? '' : 'drop-shadow(-3mm 0mm 4mm rgb(25 23 23))') : ''
      }}
      className={`relative symbol-flex max-w-[150px] bg-[#151515] ${
        props?.active ? 'active' : ''
      } ${
        props?.maxW
          ? 'animation-symbol-list hover:bg-[#151515] hover:-left-2 left-0'
          : 'animation-symbol-list-nomal'
      }`}>
      <div
        className="div-flex-center"
        onClick={() => props?.handleClick('select', props?.keyIndex, props?.symbolInfo)}>
        <img
          className="rounded-[50%]"
          src={`https://storage.googleapis.com/iux-storage/symbol/${props?.symbolInfo?.symbol}.png`}
          width="18px"
          height="18px"
          onError={({ currentTarget }) => {
            currentTarget.src = 'globe.svg';
          }}
        />
        <div className="symbol-name">{props?.symbolInfo?.symbol}</div>
      </div>
      {!props?.lastIndex ? (
        <div
          className="close-symbol relative z-10 ml-2"
          onClick={() => props?.handleClick('close', props?.keyIndex, props?.symbolInfo)}>
          <ActionIcons.Close className="stroke-[#9f9f9f] fill-[#9f9f9f] w-[12px] h-[12px]" />
        </div>
      ) : (
        <div />
      )}
    </div>
  );
});

export { SymbolItem };
